export const styles = {
  root: {
    backgroundColor: 'var(--black)',
    color: 'var(--white)',
    padding: '24px 0',
    position: 'sticky',
    top: '0',
    width: '256px',
    transition: '300ms ease-out',
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '100px',
  },
  collapse: {
    position: 'fixed',
    bottom: '10px',
    left: '8px',
  },
}
